import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store/index'

Vue.use(VueI18n)

const locales = [
  {
    locale: 'en',
    title: 'English',
    messages: require('../locales/en.json'),
    icon: 'flags/united-states-of-america-flag-round-icon-32.png'
  },
  {
    locale: 'km',
    title: 'ភាសាខ្មែរ',
    messages: require('../locales/km.json'),
    icon: 'flags/cambodia-flag-round-icon-32.png'
  }
  // {
  //   locale: 'ja',
  //   title: '日本人',
  //   messages: require('../locales/jp.json'),
  //   icon: 'flags/japan-flag-round-icon-32.png'
  // },
  // {
  //   locale: 'zh',
  //   title: '中文',
  //   messages: require('../locales/zh.json'),
  //   icon: 'flags/china-flag-round-icon-32.png'
  // }
]

function loadLocaleMessages() {
  const messages = {}
  locales.forEach((obj) => {
    messages[obj.locale] = obj.messages
  })
  return messages
}
console.warn('current language detected', store.getters['account/lang'])
export default new VueI18n({
  locale: store.getters['account/lang'],
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})

export const languages = locales
